<script>
import base from '@/functions/base'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DDLogin',
  props: {
    isKeepMore: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      clientId: '',
      gotoUrl: '',
      iframe: null
    }
  },
  mounted () {
    this.clientId = this.$urls.ddClientId // 即 clientId
    const redirectUri = encodeURIComponent(location.origin + '/#/oauth/callback')
    this.gotoUrl = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.clientId}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${redirectUri}`
    this.getDDCode()
    window.addEventListener('message', this.handleMessage, false)
  },
  methods: {
    ...mapActions(['sfLoginFn']),
    handleMessage (event) {
      const { origin, data } = event
      // 扫码时获取loginTmpCode
      if (origin === 'https://login.dingtalk.com') {
        console.log('loginTmpCode', data)
        const newUrl = `${this.gotoUrl}&loginTmpCode=${data}`
        this.createIframeFn(newUrl)
      }
      // 通过loginTmpCode获取code
      if (origin === location.origin && data.code) {
        this.getDDUnionid(data.code)
        // 移除当前iframe
        document.body.removeChild(this.iframe)
      }
    },
    getDDCode () {
      // 生成钉钉登录二维码
      const goto = encodeURIComponent(this.gotoUrl)
      window.DDLogin({
        id: 'self_defined_element',
        goto,
        style: 'border:none;background-color:var(--background-color);',
        width: '300',
        height: '300'
      })
    },
    createIframeFn (newUrl) {
      const oldIframe = document.getElementById('dingTalkCallback')
      oldIframe && oldIframe.remove()
      this.iframe = document.createElement('iframe')
      this.iframe.id = 'dingTalkCallback'
      this.iframe.src = newUrl
      this.iframe.style.display = 'none'
      document.body.appendChild(this.iframe)
    },
    getDDUnionid (authCode) {
      base.publicJSONPostRequest('/ding/auth/code', {
        authCode,
        clientId: this.clientId
      }, response => {
        const res = response.data || {}
        if (res.code === '200') {
          const { unionid } = res.data || {}
          this.getDDIsBind(unionid)
        } else {
          this.$message.error(res.msg)
        }
      }, () => {
        this.$message.error(this.$t('HuoQuWeiXinQuanXianShiBaiQingZhongXinSaoMaDengLu', [this.$t('dingDing')]))
      })
    },
    getDDIsBind (unionId) {
      base.publicGetRequest('/ding/isBind', { unionId }, res => {
        if (res.success && res.data) {
          // 已绑定 直接登录
          let wxLogin = {
            userAccount: res.data,
            dingUnionId: unionId,
            source: this.loginSource.buryingPoint,
            isKeepMore: this.isKeepMore
          }
          this.sfLoginFn({
            url: '/dingScanLogin',
            params: wxLogin
          }).then((res) => {
            let token = res.data.Authentication
            // this.$message.success('登录成功')
            this.$emit('loginSuccess', token)
          }).catch((res) => {
            this.$message.error(res.msg || this.$t('HuoQuWeiXinQuanXianShiBaiQingZhongXinSaoMaDengLu', [this.$t('dingDing')]))
          })
        } else {
          // 未绑定 去绑定
          this.$router.push(`/wxLogin?code=${unionId}&type=dd`)
        }
      }, () => {
        this.$message.error(this.$t('HuoQuWeiXinQuanXianShiBaiQingZhongXinSaoMaDengLu', [this.$t('dingDing')]))
      })
    }
  },
  beforeDestroy () {
    window.removeEventListener('message', this.handleMessage, false)
  },
  computed: {
    ...mapState({
      loginSource: state => state.publicModules.loginSource
    })
  }
}
</script>

<template>
  <div id="self_defined_element" class="self-defined-classname"></div>
</template>

<style scoped lang="scss">
.self-defined-classname{
  width: 100%;
  height: 300px;
  margin-bottom: 24px;
  text-align: center;
}
</style>
